/**
 * handleApiErr — sonner toast를 사용한 공통 API 에러 핸들러
 *
 * configure()의 onError에 직접 전달한다.
 * 401 처리는 axios interceptor에서 하고 여기선 메시지 표시만 담당한다.
 *
 * @example
 * // providers.tsx
 * import { handleApiErr, configure } from "@sunkim4638/admin-modules/api-hooks";
 *
 * configure({ axios: ax, onError: handleApiErr });
 */

"use client";

import { toast } from "sonner";
import { createApiErrorHandler } from "./create-api-error-handler";

function toastMessage(msg: string) {
    // 줄바꿈이 있으면 각 줄을 div로 분리
    if (!msg.includes("\n")) {
        toast.error(msg);
        return;
    }
    toast.error(
        <div>
            {msg.split("\n").map((line, i) => (
                <div key={i}>{line}</div>
            ))}
        </div>
    );
}

export const handleApiErr = createApiErrorHandler({
    onMessage: toastMessage,
    onForbidden: () => toastMessage("권한이 없습니다."),
    // onUnauthorized 미설정 → 401은 axios interceptor에서 처리
});
